import { render, staticRenderFns } from "./buscacarnet.vue?vue&type=template&id=3ea99f9d&"
import script from "./buscacarnet.vue?vue&type=script&lang=js&"
export * from "./buscacarnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports